import { makeAutoObservable, toJS } from 'mobx';
import { BFFGet } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import { Platform } from '@/infrastructure/utils/app';
import { ConfigTabType, getDefaultConfig } from '@/presentation/pages/setting/app-deliver-config/api';
import { CONFIG_MODE, CONFIG_FIELD_INFO } from '@/presentation/pages/setting/app-deliver-config/constant';

export class ConfigStore {
  configs: {[key: string]: any} = {};
  androidFullConfig = {};
  iosFullConfig = {};
  flutterFullConfig = {};
  windowsFullConfig = {};
  harmonyOSFullConfig = {};
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async loadOperation() {
    try {
      const { data: configMode } = await BFFGet(`/${API_PREFIX}/api/config/operation`, {
        params: {
          configName: CONFIG_MODE,
        },
      });
      const { data: configFieldInfo } = await BFFGet(`/${API_PREFIX}/api/config/operation`, {
        params: {
          configName: CONFIG_FIELD_INFO,
        },
      });
      const androidFullConfig = await getDefaultConfig(ConfigTabType.DEFAULT, Platform.Android);
      const iosFullConfig = await getDefaultConfig(ConfigTabType.DEFAULT, Platform.IOS);
      const flutterFullConfig = await getDefaultConfig(ConfigTabType.DEFAULT, Platform.Flutter);
      const windowsFullConfig = await getDefaultConfig(ConfigTabType.DEFAULT, Platform.Windows);
      const harmonyOSFullConfig = await getDefaultConfig(ConfigTabType.DEFAULT, Platform.HarmonyOS);
      this.androidFullConfig = JSON.parse(androidFullConfig);
      this.iosFullConfig = JSON.parse(iosFullConfig);
      this.flutterFullConfig = JSON.parse(flutterFullConfig);
      this.windowsFullConfig = JSON.parse(windowsFullConfig);
      this.harmonyOSFullConfig = JSON.parse(harmonyOSFullConfig);
      this.configs[CONFIG_MODE] = toJS(configMode);
      this.configs[CONFIG_FIELD_INFO] = toJS(configFieldInfo);
    } catch (e) {
      logger.error('loadOperation err:', e);
    }
  }
}
